<template>
  <div>
    <PageHead title="死亡人员详情"></PageHead>
    <div class="detial-cont">
      <div class="detial-cont-view">
        <div class="personage">
          <div class="personage-title">个人情况</div>
          <div class="personage-cont">
            <a-descriptions style="border-bottom: #e9e9e9 1px solid">
              <a-descriptions-item> 个人基本信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="姓名"
                >{{ personDetial.fullName }}
              </a-descriptions-item>
              <a-descriptions-item label="单位名称">
                {{ personDetial.departmentName }}
              </a-descriptions-item>
              <a-descriptions-item label="身份证号码">
                {{ personDetial.idCardNumber }}
              </a-descriptions-item>
              <a-descriptions-item label="出生年月">
                {{ personDetial.birthTime }}</a-descriptions-item
              >
              <a-descriptions-item label="性别">
                {{ personDetial.sex }}</a-descriptions-item
              >
              <a-descriptions-item label="年龄">
                {{ personDetial.age }}
              </a-descriptions-item>
              <a-descriptions-item label="民族">
                {{ personDetial.nation }}
              </a-descriptions-item>

              <a-descriptions-item label="籍贯">
                {{ personDetial.nativePlace }}
              </a-descriptions-item>
              <a-descriptions-item label="政治面貌">
                {{
                  getByTypeName(personDetial.politicalType, politicalTypeList)
                }}
              </a-descriptions-item>
              <a-descriptions-item label="健康状况">
                {{ getByTypeName(personDetial.healthStatus, healthStatusList) }}
              </a-descriptions-item>
              <a-descriptions-item label="技术职称">
                {{ personDetial.technicalTitle }}
              </a-descriptions-item>
              <a-descriptions-item label="军转干部/复原军人">
                {{ personDetial.militaryCadres }}
              </a-descriptions-item>
              <a-descriptions-item label="参加工作时间">
                {{ personDetial.firstWorkTime }}
              </a-descriptions-item>
              <a-descriptions-item label="进入民政系统时间">
                {{ personDetial.civilOfficeSysTime }}</a-descriptions-item
              >
              <a-descriptions-item label="户口所在地">
                {{ personDetial.registeredResidence }}
              </a-descriptions-item>
              <a-descriptions-item label="家庭地址">
                {{ personDetial.homeAddress }}
              </a-descriptions-item>
              <a-descriptions-item label="县区">
                {{ personDetial.county }}
              </a-descriptions-item>
              <a-descriptions-item label="联系方式">
                {{ personDetial.phone }}</a-descriptions-item
              >
            </a-descriptions>
            <blank height="16"> </blank>
            <a-descriptions>
              <a-descriptions-item> 学历信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="全日制教育学历">
                {{
                  getByTypeName(personDetial.firstEducation, educationList)
                }}</a-descriptions-item
              >
              <a-descriptions-item label="全日制教育学位">
                {{ personDetial.firstAcademicDegree }}</a-descriptions-item
              >
              <a-descriptions-item label="全日制教育专业">
                {{ personDetial.firstMajor }}</a-descriptions-item
              >

              <a-descriptions-item label="全日制教育毕业院校">
                {{ personDetial.firstGraduationSchool }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育学历">
                {{ getByTypeName(personDetial.education, educationList) }}
              </a-descriptions-item>
              <a-descriptions-item label="在职教育学位">
                {{ personDetial.academicDegree }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育专业">
                {{ personDetial.major }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育毕业院校">
                {{ personDetial.graduationSchool }}</a-descriptions-item
              >
            </a-descriptions>
            <blank height="16"> </blank>
            <a-descriptions>
              <a-descriptions-item> 退休信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="退休前职务">
                {{ personDetial.retirePosition }}</a-descriptions-item
              >
              <a-descriptions-item label="退休时间">
                {{ personDetial.retireTime }}</a-descriptions-item
              >
              <a-descriptions-item label="退休时身份">
                {{ personDetial.retireIdentity }}</a-descriptions-item
              >

              <a-descriptions-item label="退休类别">
                {{
                  getByTypeName(personDetial.retireType, retireTypeList)
                }}</a-descriptions-item
              >
            </a-descriptions>
            <blank height="16"> </blank>
            <a-descriptions>
              <a-descriptions-item> 死亡信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="死亡时间">
                {{ personDetial.deathTime }}</a-descriptions-item
              >
              <a-descriptions-item label="死亡档案号">
                {{ personDetial.deathNumber }}</a-descriptions-item
              >
              <a-descriptions-item label="办理人姓名">
                {{ personDetial.handleName }}</a-descriptions-item
              >

              <a-descriptions-item label="办理人手机号">
                {{ personDetial.handlePhone }}</a-descriptions-item
              >
              <a-descriptions-item label="办理人身份证号">
                {{ personDetial.handleCardNo }}</a-descriptions-item
              >
              <a-descriptions-item label="备注">
                {{ personDetial.description }}</a-descriptions-item
              >
            </a-descriptions>
          </div>
        </div>
      </div>
    </div>
    <!-- 三列展示表格 -->
    <div class="detial-cont">
      <div class="detial-cont-title">死亡档案</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <div>
          <a-table
            :pagination="false"
            :columns="columnsDeathFileList"
            :data-source="personDetial.deathPersonnelManagerFileList"
            :row-key="(record) => record.index"
          >
            <div slot="action" slot-scope="text, record">
              <a-button type="link" class="btn-link" @click="goDetial(record)">
                查看
              </a-button>
              <a-divider type="vertical" />
              <a-button
                type="link"
                class="btn-link"
                @click="
                  download(
                    record.mongoFileId,
                    record.filename,
                    record.fileformat
                  )
                "
              >
                下载
              </a-button>
            </div>
          </a-table>
        </div>
      </div>
    </div>
    <!-- 遗属待遇办理进度 -->
    <div class="detial-cont">
      <div class="detial-cont-title">遗属待遇办理进度</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <div>
          <a-table
            :pagination="false"
            :columns="columnsDeathWillHandleList"
            :data-source="personDetial.deathWillHandleList"
            :row-key="(record) => record.index"
          >
            <div slot="number" slot-scope="text, record, index">
              {{ index + 1 }}
            </div>
          </a-table>
        </div>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">开具材料情况</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <div>
          <a-table
            :pagination="false"
            :columns="columnsDeathMaterialScienceList"
            :data-source="personDetial.deathMaterialScienceList"
            :row-key="(record) => record.index"
          >
            <div slot="number" slot-scope="text, record, index">
              {{ index + 1 }}
            </div>
            <div slot="action" slot-scope="text, record">
              <a-button type="link" class="btn-link" @click="goDetial(record)">
                查看
              </a-button>
              <a-divider type="vertical" />
              <a-button
                type="link"
                class="btn-link"
                @click="
                  download(
                    record.mongoFileId,
                    record.filename,
                    record.fileformat
                  )
                "
              >
                下载
              </a-button>
            </div>
          </a-table>
        </div>
      </div>
    </div>
    <appfloor v-if="version || year || month"></appfloor>
    <bottomSuspension v-else>
      <a-button :style="{ marginRight: '26px' }" @click="goback">
        返回
      </a-button>
    </bottomSuspension>
  </div>
</template>

<script>
const columnsDeathFileList = [
  {
    key: 'filename',
    dataIndex: 'filename',
    title: '档案名称',
    align: 'left'
  },
  {
    key: 'fileformat',
    dataIndex: 'fileformat',
    title: '文件格式',
    align: 'left'
  },

  {
    key: 'createTime',
    dataIndex: 'createTime',
    title: '上传时间',
    align: 'left'
  },
  {
    key: 'createUserId',
    dataIndex: 'createUserId',
    title: '操作人',
    align: 'left'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
const columnsDeathWillHandleList = [
  {
    key: 'number',
    scopedSlots: { customRender: 'number' },
    title: '序号',
    align: 'left',
    width: 120
  },
  {
    key: 'handleTime',
    dataIndex: 'handleTime',
    title: '办理时间',
    align: 'left'
  },
  {
    key: 'handleMatter',
    dataIndex: 'handleMatter',
    title: '遗嘱办理事项',
    align: 'left'
  },

  {
    key: 'handleName',
    dataIndex: 'handleName',
    title: '办理人',
    align: 'left'
  },
  {
    key: 'description',
    dataIndex: 'description',
    title: '备注',
    align: 'left'
  }
]
const columnsDeathMaterialScienceList = [
  {
    key: 'number',
    scopedSlots: { customRender: 'number' },
    title: '序号',
    align: 'left',
    width: 120
  },
  {
    key: 'createTime',
    dataIndex: 'createTime',
    title: '开具材料时间',
    align: 'left'
  },
  {
    key: 'materialScienceName',
    dataIndex: 'materialScienceName',
    title: '开具材料名称',
    align: 'left'
  },

  {
    key: 'handleName',
    dataIndex: 'handleName',
    title: '办理人',
    align: 'left'
  },
  {
    key: 'description',
    dataIndex: 'description',
    title: '备注',
    align: 'left'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import {
  deathPersonnelManagerPersonnelGet,
  deathPersonnelManagerHistoryGet,
  getJobDetial
} from '../api/api'
import { formatDateNoDetails } from '@/assets/js/auth'
import { mapState, mapActions } from 'vuex'
import { getFile } from '@/http/url'

export default {
  components: {},
  data() {
    return {
      confirmLoading: false,
      personDetial: {}, // 详情
      id: '',
      version: '', //历史版本
      year: '', // 年
      month: '', // 月
      columnsDeathFileList, // 死亡档案表-列
      columnsDeathWillHandleList, // 遗嘱办理进度表-列
      columnsDeathMaterialScienceList // 开具材料情况表-列
    }
  },
  computed: {
    ...mapState({
      positionList: (state) => state.bytype.positionList, //行政职务
      positionLevelList: (state) => state.bytype.positionLevelList, //职级
      politicalTypeList: (state) => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: (state) => state.bytype.contractTypeList, //劳动合同类型
      educationList: (state) => state.bytype.educationList, //学历
      registeredNatureList: (state) => state.bytype.registeredNatureList, //户口性质
      healthStatusList: (state) => state.bytype.healthStatusList, //健康状况
      positionStatusList: (state) => state.bytype.positionStatusList, //减员原因
      retireTypeList: (state) => state.bytype.retireTypeList // 退休类别
    })
  },
  created() {
    this.id = this.$route.query.id
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.year = this.$route.query.year ? this.$route.query.year : ''
    this.month = this.$route.query.month ? this.$route.query.month : ''
    if (this.version) {
      //历史修改版本 deathPersonnelManagerHistoryGet
      deathPersonnelManagerHistoryGet({
        id: this.id,
        version: this.version
      }).then((res) => {
        if (res.data.code == 0) {
          this.personDetial = res.data.data
        }
      })
    } else if (this.year && this.month) {
      //历史版本
      getJobDetial({ id: this.id, year: this.year, month: this.month }).then(
        (res) => {
          if (res.data.code == 0) {
            this.personDetial = res.data.data
          }
        }
      )
    } else {
      // 正常详情
      deathPersonnelManagerPersonnelGet(this.id).then((res) => {
        if (res.data.code == 0) {
          this.personDetial = res.data.data
        }
      })
    }
    this.getByType()
  },
  methods: {
    ...mapActions([
      'getposition',
      'getpositionLevel',
      'getpoliticalType',
      'getcontractType',
      'geteducation',
      'getregisteredNature',
      'getpositionStatus',
      'gethealthStatus',
      'getRetireTypeList'
    ]),
    formatDateIt(data) {
      // 时间格式化
      return formatDateNoDetails(data)
    },
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    // 获取当前页面所需字典表
    getByType() {
      //减员原因
      this.getpositionStatus()
      //行政职务
      this.getposition()
      //职级
      this.getpositionLevel()
      //政治面貌
      this.getpoliticalType()
      //劳动合同类型
      this.getcontractType()
      //学历
      this.geteducation()
      //户口性质
      this.getregisteredNature()
      //健康状况
      this.gethealthStatus(),
        // 退休类别
        this.getRetireTypeList()
    },
    goback() {
      this.$router.back()
    },
    // 查看附件
    goDetial(item) {
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    // 下载附件
    download(mongoFileId, filename, fileformat) {
      this.$message.success('下载中')
      getFile(mongoFileId).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    }
  }
}
</script>
<style scoped>
/deep/ .ant-descriptions-view table {
  border-collapse: separate;
}
/deep/ .ant-descriptions-view table tbody tr th,
/deep/ .ant-descriptions-view table tbody tr td {
  border: none !important;
  border: 0 !important;
  background: #fff;
}
/deep/ .ant-descriptions-view table tbody tr {
  border: none !important;
  border: 0 !important;
}
.print-poths .print-title,
.print-poths .isImg {
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>
.detial-cont {
  margin: 24px 16px;

  .detial-cont-title {
    background: #fff;
    height: 55px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 55px;
    text-align: left;
    padding-left: 32px;
  }
  .detial-cont-view {
    background: #fff;
    padding: 30px;
    .personage {
      // height: 360px;
      border: #e9e9e9 solid 1px;
      border-radius: 4px;
      .personage-title {
        padding-left: 24px;
        height: 44px;
        color: rgba(0, 0, 0, 0.85);
        background-color: rgba(250, 250, 250, 1);
        border-bottom: #e9e9e9 solid 1px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 44px;
      }
      .personage-cont {
        padding: 16px 24px 0 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.ant-descriptions-view {
  border-radius: 0px !important;
}
.ant-descriptions-bordered .ant-descriptions-item-label {
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheDead/detail.vue